import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  ChevronUp,
  PlusCircle,
  RotateCcw,
} from "feather-icons-react/build/IconComponents";
import { OverlayTrigger, Tooltip, Modal } from "react-bootstrap";
import { setToogleHeader } from "../../../core/redux/action";
import { useCheckUserPermission } from "../../common/userPermission";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import { all_routes } from "../../../Router/all_routes";
import { exportToExcel } from "../../common/Export/ExcelExport";
import PDFExport from "../../common/Export/PdfExport";

function HeaderModule({
  refreshData,
  exportData = [],
  addMasterPageLink = "",
  showImport = false,
}) {
  const location = useLocation();
  const parts = location.pathname;
  let pathname = parts?.trim()?.split("/");
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const data = useSelector((state) => state.toggle_header);
  //   const route = all_routes;
  const [showModal, setShowModal] = useState(false);
  console.log(addMasterPageLink, "addMasterPageLink");

  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      Pdf
    </Tooltip>
  );
  const renderExcelTooltip = (props) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );
  //   const renderPrinterTooltip = (props) => (
  //     <Tooltip id="printer-tooltip" {...props}>
  //       Printer
  //     </Tooltip>
  //   );
  const renderRefreshTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Refresh
    </Tooltip>
  );
  const renderCollapseTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Collapse
    </Tooltip>
  );

  return (
    <>
      <div className="page-header">
        <div className="add-item d-flex">
          <div className="page-title">
            <h3 className="text-color-70">{pathname[1]}</h3>
            <h6 className="text-color-40">Manage your {pathname[1]}</h6>
          </div>
        </div>
        <ul className="table-top-head">
          <li>
            <OverlayTrigger placement="top" overlay={renderTooltip}>
              <Link onClick={() => setShowModal(true)}>
                <ImageWithBasePath src="assets/img/icons/pdf.svg" alt="img" />
              </Link>
            </OverlayTrigger>
          </li>
          <li>
            <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
              <Link
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                onClick={() => exportToExcel(exportData, pathname[1])}
              >
                <ImageWithBasePath src="assets/img/icons/excel.svg" alt="img" />
              </Link>
            </OverlayTrigger>
          </li>
          <li>
            <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
              <Link
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                onClick={() => refreshData()}
              >
                <RotateCcw />
              </Link>
            </OverlayTrigger>
          </li>
          <li>
            <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
              <Link
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                id="collapse-header"
                className={data ? "active" : ""}
                onClick={(e) => {
                  e.preventDefault();
                  dispatch(setToogleHeader(!data));
                }}
              >
                <ChevronUp />
              </Link>
            </OverlayTrigger>
          </li>
        </ul>
        {useCheckUserPermission(addMasterPageLink) && (
          <div className="page-btn">
            <button onClick={() => navigate(addMasterPageLink)} className="btn btn-primary btn-md btn-wave me-2">
              <PlusCircle className="me-2 iconsize" />
              Add {pathname[1]}
            </button>
          </div>
        )}
        {(useCheckUserPermission(all_routes?.customerImport) && showImport ) && (
          <div className="page-btn">
            <button onClick={() => navigate(all_routes?.customerImport)} className="btn btn-primary btn-md btn-wave me-2">
              <PlusCircle className="me-2 iconsize" />
              Import Customers
            </button>
          </div>
        )}
      </div>

      {/* Bootstrap Modal */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        size="xl"
        fullscreen="xl-down"
      >
        <Modal.Header closeButton>
          <Modal.Title>PDF Preview</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {showModal && (
            <PDFExport exportData={exportData} fileName={pathname[1]} />
          )}
        </Modal.Body>
        <Modal.Footer>
          {/* <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button> */}
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default HeaderModule;
